import {folderSvg as Icon__small__folderSvg} from '../Icon__small/Icon__small--folder.js'

export var folder = {
  name: 'folder',
  category: 'icon',
  colorable: true,
  svg: Icon__small__folderSvg,
};
